import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";


// *********************************** Manage User ***********************************************
export const getbhaktaparivar = async (data) => {
  return decryptData(
    await axios.get(
      `/getfollowerslist?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getDistrictdropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getdistricts?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const addbhaktaparivar = async (data) => {
  return decryptData(
    await axios.post(`/addfollower`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const getbhaktaparivarById = async (data) => {
  return decryptData(
    await axios.get(
      `/getfollowerbyid?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updatebhaktaparivar = async (data) => {
  return decryptData(
    await axios.post(`/updatefollower`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};